import { ITicket } from "./entities/ticket";

export enum TicketSortingField {
  LastMessageAt = "lastMessageAt",
  // Currently, only lastMessageAt is supported. The UI doesn't show the other columns and we're not receiving them from the API.
  // However, it is possible to sort the tickets by these fields (https://api.helpdesk.com/docs#operation/ticketList).
  // Due to the mechanism of FE-side sorting implemented in the websocket sagas, these fields HAVE TO exist on the incoming tickets' data, hence the mapping below.
  // CreatedAt = "createdAt"
  // UpdatedAt = "updatedAt",
}

export const mapTicketSortingFieldToTicketField: Record<TicketSortingField, keyof ITicket> = {
  [TicketSortingField.LastMessageAt]: "lastMessageAt",
};

export enum TicketSortingOrder {
  Ascending = "asc",
  Descending = "desc",
}

export interface ITicketSorting {
  field: TicketSortingField;
  order: TicketSortingOrder;
}
